<template>
    <div class=""> 
        <div class="text-16 text-a-gray-555555 pb-5">กรุณากรอกข้อมูล</div>

        <InputNationalId 
            v-model:inputValue="form.thai_citizen_id" 
            :errorInfo="errorInfo[0]" 
            :isShowError="true"
            :isSubmitted="isSubmitted" 
            :inputLbl="lbl.standard_register.idCard" />

        <InputContactNumber 
            v-model:inputValue="form.phone_number" 
            delimeter="-" 
            :maxLength="12" 
            :minLength="12"
            :errorInfo="errorInfo[1]" 
            :isShowError="true" 
            :isSubmitted="isSubmitted"
            :inputLbl="lbl.standard_register.contactNumber" 
            @update:inputValue="onFormUpdate()" /> 
    </div>
</template>
<script>
import {  FormHelper } from '@/helper/FormHelper';
import CacheHelper from '@/helper/CacheHelper';

//component 
import InputContactNumber from '@/components/Input/label/InputContactNumber.vue';
import InputNationalId from '@/components/Input/label/InputNationalId.vue'; 
//mixin
import LocaleMixin from '@/mixin/LocaleMixin'
//service
import { StandardRegisterModel } from '../../model/StandardRegisterModel'; 

import { ref, watch } from 'vue';

export default {
    name: 'FormRegister',
    mixins: [LocaleMixin],
    components: { 
        InputContactNumber,
        InputNationalId, 
    },
    props:{
        modelValue: { type: Boolean}
    },
    emits: ["update:modelValue"],
    data: function () {
        return {
            isSubmitted: false,  
        };
    },
    computed: {
        
    },
    created: function () { 
        
    },
    setup: function(props, ctx){
        const errorInfo = ref(FormHelper.genErrorInfo(2))
        const form = ref(new StandardRegisterModel()) 
        const formValid = ref(false)

        watch(errorInfo, ()=>{
            let valid = FormHelper.validate(errorInfo.value) 
            if(valid){
                ctx.emit("update:modelValue", valid)
            }
        }, {
            deep: true
        })

        return {
            form,
            formValid,
            errorInfo
        }
    },
    methods: {
        validate: function () {
            this.isSubmitted = true;
            let valid = FormHelper.validate(this.errorInfo);
            return valid;
        },
        getValue: function () { 
            return this.form;
        },

        onFormUpdate: function () {
            this.saveCacheForm();
        },
        saveCacheForm: function () {
            let cache = new CacheHelper('session');
            cache.setCache('form_standardregister', this.form); 
        },
        restoreForm: function () {
            let cache = new CacheHelper('session');
            let form = cache.getCache('form_standardregister'); 

            if (form != null) {
                this.form.setValueFromCache(form);
            } 
        },
    },
}
</script>
